<template>
  <v-card elevation="0" height="100%" class="overflow-hidden">
    <v-card-title v-if="list_comments.length > 0" style="width: 100%">
      <v-btn icon @click="closeWindowEstimation">
        <v-icon size="15px">
          fa-chevron-left
        </v-icon>
      </v-btn>
      Составление комментария
    </v-card-title>

    <v-divider/>

    <v-card-text :style="`height: calc(100% - ${indent});`" class="overflow-auto">
<!--      <v-row justify="center" class="mt-2">-->
<!--        <v-col cols="6">-->
<!--          <v-autocomplete-->
<!--              v-model="data_comment.provision_status"-->
<!--              :items="provision_statuses"-->
<!--              label="Обеспечивание учебного процесса"-->
<!--              :rules="[v => !!v || 'Обязательное поле не заполнено']"-->
<!--              no-data-text="Данные отсутствуют"-->
<!--              dense-->
<!--              hide-details-->
<!--              rounded-->
<!--              outlined-->
<!--          ></v-autocomplete>-->
<!--        </v-col>-->
<!--        <v-col cols="6">-->
<!--          <v-autocomplete-->
<!--              v-model="data_comment.access_status"-->
<!--              :items="access_statuses"-->
<!--              :rules="[v => !!v || 'Обязательное поле не заполнено']"-->
<!--              no-data-text="Данные отсутствуют"-->
<!--              label="Размещение в СДО Moodle"-->
<!--              dense-->
<!--              hide-details-->
<!--              rounded-->
<!--              outlined-->
<!--          ></v-autocomplete>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--      <v-checkbox v-model="checkbox_addit_message">-->
<!--        <template v-slot:label>-->
<!--          <div>-->
<!--            Оставить дополнительно комментарий-->
<!--          </div>-->
<!--        </template>-->
<!--      </v-checkbox>-->
<!--      <v-slide-x-transition>-->
        <v-textarea
            class="rounded-xl"
            v-model="addit_message"
            outlined
            height="400px"
            label="Поле для комментария"
        ></v-textarea>
<!--      </v-slide-x-transition>-->
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="6">
          <v-btn
              @click="rejection(selected_tech_map)"
              elevation="0"
              color="red"
              outlined
              rounded
              block
          >
            Отклонить
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              @click="approvement(selected_tech_map)"
              color="green"
              elevation="0"
              outlined
              rounded
              block
          >
            Подтвердить
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "CardEstimation",
  props: {
    selected_tech_map: {
      type: Object
    },
    role_key: {
      type: Number
    }
  },
  data: () => ({
    checkbox_addit_message: false,
    data_comment: {
      provision_status: '',
      access_status: '',
    },
    addit_message: '',
    provision_statuses: ['Обеспечивает', 'Не обеспечивает', 'Частично'],
    access_statuses: ['Рекомендуется', 'Не рекомендуется'],
  }),
  mounted() {
  },
  computed: {
    ...mapState({
      list_comments: state => state.studyEstEukTechMapCommission.list_comments,
    }),
    indent() {
      if (this.list_comments.length > 0) {
        return '125px'
      }
      return '55px'
    }
  },
  methods: {
    ...mapActions({
      updateCommissionStatus: 'studyEstEukTechMapCommission/updateCommissionStatus',
    }),
    rejection(selected_tech_map) {
      let commission_status = {
        role_key: this.role_key,
        technological_map_id: selected_tech_map.id,
        status_review: 3,
        data_comment: '',
        addit_message: this.addit_message
      }

      this.updateCommissionStatus(commission_status).then(() => {
        this.closeWindowEstimation()
        this.setDefaultDataCommission()
      })
    },
    approvement(selected_tech_map) {
      let commission_status = {
        role_key: this.role_key,
        technological_map_id: selected_tech_map.id,
        status_review: 2,
        data_comment: '',
        addit_message: this.addit_message
      }
      this.updateCommissionStatus(commission_status).then(() => {
        this.closeWindowEstimation()
        this.setDefaultDataCommission()
      })
    },
    setDefaultDataCommission() {
      this.checkbox_addit_message = false
      this.data_comment = {
        provision_status: '',
        access_status: '',
      }
      this.addit_message = ''
    },
    closeWindowEstimation() {
      this.$emit('closeWindowEstimation')
    },
  }
}
</script>

<style scoped>

</style>